/**
 * WHICH ROUTE OWNS THE WHOLE PIECE OF GLASS — asked by BOTH frames, so they cannot disagree.
 *
 * 🚨 A SCREEN CANNOT BLEED PAST A FRAME THAT CLIPS IT, AND THAT IS THE WHOLE REASON THIS
 * EXISTS. The timer paints its own background and pulled the frame's padding back with a
 * negative margin — which does nothing, because `ScreenTransition`'s stack is
 * `overflow-x-hidden` and a box with one axis hidden clips the other too. Measured, not
 * reasoned about: the scrolling ancestor's top edge sat at 12px, the ground was laid out at 0
 * and painted from 12, and the app's near-black background showed through as a bar across the
 * top of the phone. The top four pixels of the heart-rate pill went with it.
 *
 * So the padding has to be absent rather than cancelled, which means the FRAMES have to know.
 * Two of them do — `__root.tsx` owns the safe-area inset and `_app.tsx` owns the shell's own
 * padding — and a predicate written out twice is one that drifts the first time the route
 * moves. It lives here, once, where both can reach it.
 *
 * ⚠️ THE MATCH IS EXACT AND DELIBERATELY NARROW: `/session/<id>/timer` and nothing else in the
 * session flow. The strength log and the debrief are pushed screens in the same flow and keep
 * the frame's insets, because neither has agreed to lose them — see `fullBleed` in `_app.tsx`
 * for what a screen has to provide in exchange.
 */
const FULL_BLEED = /^\/session\/[^/]+\/timer\/?$/;

export function isFullBleedRoute(pathname: string): boolean {
  return FULL_BLEED.test(pathname);
}
